import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PrEntity } from './pr-entity.model';

export class InstitutionDetailsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'InstitutionDetailsConfiguration';
  readonly reportSection = ReportSection.InstitutionDetails;
  applicableReportTypes = [ReportType.Institution, ReportType.Contact];
  minSize = 2;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections = [
    {
      name: 'institutionDetailsName',
      displayName: 'Institution Name',
      isSelected: true,
      canConfigure: true,
      applicableReportTypes: [ReportType.Contact]
    },
    {
      name: 'institutionDetailsType',
      displayName: 'Type',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionDetailsAssetClass',
      displayName: 'Asset Class',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionDetailsOrientation',
      displayName: 'Orientation',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionDetailsStyle',
      displayName: 'Style',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionDetailsTurnover',
      displayName: 'Equity Portfolio Turnover',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionDetailsFITurnover',
      displayName: 'Fixed Income Portfolio Turnover',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionDetailsTotalAssets',
      displayName: 'Total Assets (USD, mm)',
      isSelected: false,
      canConfigure: true
    },
    {
      name: 'institutionDetailsEquityAssets',
      displayName: 'EQ Assets (USD, mm)',
      isSelected: false,
      canConfigure: true
    },
    {
      name: 'institutionDetailsFIAssets',
      displayName: 'FI Assets (USD, mm)',
      isSelected: false,
      canConfigure: true
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.Contact) {
      return 'contactInstitutionDetails';
    } else if (this.appliedReportType === ReportType.Institution) {
      return 'institutionDetails';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.Contact) {
      return 'Primary Institution Details';
    } else if (this.appliedReportType === ReportType.Institution) {
      return 'Institution Details';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get nodataLocalizationKeyName(): string {
    if (this.appliedReportType === ReportType.Contact) {
      return 'primaryInstitutionDetails';
    } else if (this.appliedReportType === ReportType.Institution) {
      return 'institutionDetails';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get reportViewModelSections(): ReportViewModelSection[] {
    if (this.appliedReportType === ReportType.Contact) {
      return [ReportViewModelSection.InvestorProfile_PrimaryInstitutionDetails];
    } else if (this.appliedReportType === ReportType.Institution) {
      return [ReportViewModelSection.InvestorProfile_InstitutionInvestorDetails];
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface InstitutionDetailsData {
  [ReportViewModelSection.InvestorProfile_InstitutionInvestorDetails]: {
    prEntity: PrEntity;
  };
  [ReportViewModelSection.InvestorProfile_PrimaryInstitutionDetails]: {
    prEntity: PrEntity;
  };
}
